<template>
    <page>
        <module>
            <view-list ref="view" :work-type="workType" selector :view-config="saasInfo.viewmanage">
                <template #search>
                    <m-search ref="search">
                        <m-search-item label="背贴码">
                            <m-code-batch-input name="produce_unique_codes" field-name="背贴码" placeholder="请输入背贴码，支持批量"></m-code-batch-input>
                        </m-search-item>
                        <m-search-item label="IMEI">
                            <m-code-batch-input name="produce_imeis" field-name="IMEI" placeholder="请输入IMEI，支持批量"></m-code-batch-input>
                        </m-search-item>
                        <m-search-item label="打印状态">
                            <c-select name="print_state" :options="PRINT_STATE"></c-select>
                        </m-search-item>
                        <m-search-item label="采集人">
                            <c-select name="create_user_id" async @search="searchUser" required></c-select>
                        </m-search-item>
                        <m-search-item label="采集时间">
                            <c-datetime range start-name="create_date_start_date" end-name="create_date_end_date"></c-datetime>
                        </m-search-item>
                    </m-search>
                </template>

                <template #operate>
                    <c-button color="main" v-if="auth('b_product_unique_code_create')"
                              prepend-icon="tf-add"
                              @click="$refs.productUniqueCodeCreate.open()">批量采集背贴码
                    </c-button>
                    <c-button v-if="auth('b_product_unique_code_print')"  prepend-icon="tf-print" @click="batchPrintByTemplate()">批量打印
                    </c-button>
                    <c-button v-if="auth('b_product_unique_code_delete')"  prepend-icon="tf-trash" color="red" :hollow="true" @click="remove">批量删除
                    </c-button>
                </template>
                <!--产品信息-->
                <template #product_info="{data}">
                    <m-product-info :name="getProductText(data)" :level="data.level_type" :code="data.produce_unique_code" :imei="data.produce_imei"></m-product-info>
                </template>

				<template #produce_unique_code="{data}">
					{{data.produce_unique_code}} <c-link color="gray" @click="$copy(data.produce_unique_code)"><i class="tf">&#xe6b0;</i></c-link>
				</template>

				<template #produce_imei="{data}">
					{{data.produce_imei}} <c-link v-if="data.produce_imei" color="gray" @click="$copy(data.produce_imei)"><i class="tf">&#xe6b0;</i></c-link>
				</template>
                
                <!--等级-->
                <template #level_type="{data}">
                    <c-state tag async dict="LEVEL_TYPE" :value="data.level_type"></c-state>
                </template>
                <!--背贴码主状态-->
                <template #main_state="{data}">
                    <c-state tag async dict="UNIQUE_CODE_MAIN_STATE" :value="data.main_state"></c-state>
                </template>
                <!--背贴码详细状态-->
                <template #state="{data}">
                    <c-state tag async dict="UNIQUE_CODE_STATE" :value="data.state"></c-state>
                </template>
                <!--打印状态-->
                <template #print_state="{data}">
                    <c-state tag async dict="PRINT_STATE" :value="data.print_state"></c-state>
                </template>
                <!--关联采购单-->
                <template #purchase_code="{data}">
                    <span v-if="data.purchase_code">
                        <c-link v-if="auth('m_purchase_offline') || auth('m_purchase_online') || auth('m_purchase_bidding')" class="link-text"
                                @click="globalDialog('purchaseDetail', {props: {id:data.purchase_order_id}})">
                        {{data.purchase_code}}
                        </c-link>
                        <span v-else>
                            {{data.purchase_code}}
                        </span>
                    </span>
                    <span v-else>-</span>
                </template>

                <c-table-column
                        type="button"
                        label="操作"
                        width="120"
                        button-limit="6"
                >
                    <template #default="{data}">
                        <c-table-button icon="tf-detail" @click="globalDialog('produceUniqueCodeDetail', {props: {produce_unique_code:data.produce_unique_code}})">跟踪</c-table-button>
                        <c-table-button v-if="auth('b_product_unique_code_print') && data.print_state == 0" icon="tf-print" @click="batchPrintByTemplate(data)">打印</c-table-button>
                        <c-table-button v-if="auth('b_product_unique_code_print') && data.print_state == 1" icon="tf-print" @click="batchPrintByTemplate(data)">重新打印</c-table-button>
                        <c-table-button v-if="auth('b_product_unique_code_delete') && data.main_state == 1" icon="tf-trash" color="red" @click="remove(data)">删除</c-table-button>
                    </template>
                </c-table-column>
            </view-list>
            <!--唯一码采集弹窗-->
            <product-unique-code-create ref="productUniqueCodeCreate" @resolve="$refs.view.update()"></product-unique-code-create>
        </module>
    </page>
</template>

<script>
import {mapState} from 'vuex'
import {asyncMapState} from '@/store'
import productUniqueCodeCreate from "@/pages/product/product_unique_code_create.vue";

export default {
    name:'m_product_unique_code',
    components: {productUniqueCodeCreate},

    computed: {
        ...mapState(['saasInfo','userInfo']),
        ...asyncMapState(['PRINT_STATE'])
    },

    data() {
        return {
            workType: 9
        }
    },
    methods: {
        /************搜索用户*******************************/
        searchUser(keyword, resolve) {
            let paramData = {
                user_type: 1,
                options_code: 'SYSUSER',
                keyword: keyword
            };
            this.request({
                url: '/system/options',
                data: paramData,
                success: data => {
                    resolve(data);
                }
            })
        },
        /*********获取产品信息文字**********/
        getProductText(data) {
            var parts = [];
            if (data.brand_name) parts.push(data.brand_name);
            if (data.spu_model_name) parts.push(data.spu_model_name);
            if (data.color_name) parts.push(data.color_name);
            if (data.memory_name) parts.push(data.memory_name);
            return parts.join(' ') || '-';
        },
        //条码打印
        batchPrintByTemplate(data){
            var ids = [];
            if (data) {
                ids.push(data.id);
            } else {
                this.$refs.view.$refs.list.getData('selected').forEach(item => {
                    ids.push(item.id);
                });
            }
            if (!ids || ids.length == 0){
                this.$message({
                    type: 'warn',
                    message: '请选择需要打印的背贴码记录'
                });
            }else {
                this.$refs.view.batchPrintByTemplate(ids);
                //刷新页面
                setTimeout(() => {
                    this.$refs.view.update();
                }, 1000);
            }
        },
        /****删除条码****/
        remove(data) {
            var deleteFlag = true;//是否允许删除
            var ids = [];
            var message = "";
            if (data) {
                if (data.main_state != 1) {
                    this.$message({
                        type: 'warn',
                        message: '只能删除【待绑定】状态的背贴码!'
                    });
                    deleteFlag = false;
                    return;
                }
                ids.push(data.id);
                message = '确认删除背贴码【' + data.produce_unique_code + '】？删除后不可恢复，请谨慎操作';
            } else {
                this.$refs.view.$refs.list.getData('selected').forEach(item => {
                    if (item.main_state != 1) {
                        this.$message({
                            type: 'warn',
                            message: '只能删除【待绑定】状态的背贴码!'
                        });
                        deleteFlag = false;
                        return;
                    }
                    ids.push(item.id);
                });
                if (deleteFlag && (!ids || ids.length == 0)){
                    this.$message({
                        type: 'warn',
                        message: '请选择需要删除的背贴码数据'
                    });
                    deleteFlag = false;
                    return;
                }
                message = '确认删除' + ids.length + '条背贴码记录吗？删除后不可恢复，请谨慎操作';
            }
            if (deleteFlag) {
                this.$confirm({
                    message: message,  // 提示内容,
                    buttonName: '确认删除',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: '/product/unique_code/remove',
                            data: {unique_code_ids: ids},
                            loading: true,
                            success: data => {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功'
                                });
                                //刷新
                                this.$refs.view.update();
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {
                    },  // 取消按钮回调
                });
            }
        },
    }
}
</script>

<style lang="stylus" scoped>
</style>
